import React from 'react';
import { twJoin } from 'tailwind-merge';
import { ParagraphCollectionFragment } from '@/integrations/crystallize/__gql-codegen-types/catalogue/graphql';
import formatPunctuation from '@/ui/utils/formatPunctuation';
import { RichTextRenderer } from '../RichTextRenderer/RichTextRenderer';
import OptimizedImage from '../../shared/OptimizedImage';

export type ParagraphCollectionRendererProps = {
  content: ParagraphCollectionFragment;
  removeParagraphMargins?: boolean | null;
  titleClassName?: string;
  bodyClassName?: string;
  // handles punctuation elements to make them more "Nuki" style
  highlightTitlePunctuation?: boolean;
};

export function ParagraphCollectionRenderer({
  content,
  removeParagraphMargins,
  titleClassName,
  bodyClassName,
  highlightTitlePunctuation,
}: ParagraphCollectionRendererProps) {
  const paragraphs = content?.paragraphs;

  if (!paragraphs) {
    return null;
  }

  return paragraphs.map((paragraph, index) => (
    <div
      key={`paragraph-${index}`}
      className={twJoin(!removeParagraphMargins && 'py-2 sm:py-4 lg:py-8')}
    >
      {/* Optional Title */}
      {paragraph.title?.text && (
        <h2 style={{ fontWeight: 700 }} className={titleClassName}>
          {highlightTitlePunctuation
            ? formatPunctuation(paragraph.title.text)
            : paragraph.title.text}
        </h2>
      )}

      {/* Body Content using RichTextRenderer */}
      <RichTextRenderer blocks={paragraph.body} className={bodyClassName} />

      {/* Images */}
      {paragraph?.images?.map((image) => (
        <OptimizedImage
          key={image.url}
          image={image}
          width={1000}
          height={1000}
          sizes="(max-width: 768px) 100vw, 768px"
          className=" my-4 sm:my-6"
        />
      ))}
    </div>
  ));
}
